export type ValidationPresentation = {
  label: string;
  statusClass: string;
};

export const getValidationPresentation = (
  validationState: string,
  intakeType: string,
): ValidationPresentation => {
  if (intakeType === 'existing_story' && validationState === 'invalid') {
    return {
      label: 'needs cleanup',
      statusClass: 'needs-cleanup',
    };
  }

  return {
    label: validationState.replace(/_/g, ' '),
    statusClass: validationState,
  };
};
